import { create } from 'zustand'
import type { IAuthUser } from '@/shared/types/auth-user'
import type { AppAbility } from '@/shared/lib/casl/permissions'
import { defineAbilitiesFor } from '@/shared/lib/casl/abilities'
import { readStoredUser } from '@/shared/utils/read-stored-user'

export interface AbilityStore {
  abilities: AppAbility
  syncFromUser: (user: IAuthUser | null) => void
}

export const useAbilityStore = create<AbilityStore>((set) => ({
  abilities: defineAbilitiesFor(readStoredUser()),
  syncFromUser: (user) => set({ abilities: defineAbilitiesFor(user) }),
}))
